(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bokksu-about-qa"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-bokksu-about-qa]').forEach((section) => {
    if (section.dataset.aboutQaReady === 'true') return;
    section.dataset.aboutQaReady = 'true';
    const questions = Array.from(section.querySelectorAll('[data-bokksu-about-question]'));
    questions.forEach((button) => {
      button.addEventListener('click', () => {
        const willOpen = button.getAttribute('aria-expanded') !== 'true';
        questions.forEach((otherButton) => {
          const panelId = otherButton.getAttribute('aria-controls');
          const panel = panelId ? document.getElementById(panelId) : null;
          const open = otherButton === button && willOpen;
          otherButton.setAttribute('aria-expanded', String(open));
          if (panel) panel.hidden = !open;
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bokksu-about-route"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-bokksu-about-route]').forEach((route) => {
    if (route.dataset.aboutRouteReady === 'true') return;
    route.dataset.aboutRouteReady = 'true';

    const questions = Array.from(route.querySelectorAll('[data-bokksu-about-question]'));
    questions.forEach((button) => {
      button.addEventListener('click', () => {
        const willOpen = button.getAttribute('aria-expanded') !== 'true';
        questions.forEach((otherButton) => {
          const panelId = otherButton.getAttribute('aria-controls');
          const panel = panelId ? document.getElementById(panelId) : null;
          const open = otherButton === button && willOpen;
          otherButton.setAttribute('aria-expanded', String(open));
          if (panel) panel.hidden = !open;
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bokksu-collection-route"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-bokksu-collection-route]').forEach((route) => {
    if (route.dataset.collectionReady === 'true') return;
    route.dataset.collectionReady = 'true';
    route.querySelector('[data-bokksu-sort]')?.addEventListener('change', (event) => {
      event.currentTarget.form?.requestSubmit();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bokksu-contact-route"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-bokksu-contact-route]').forEach((route) => {
    if (route.dataset.contactRouteReady === 'true') return;
    route.dataset.contactRouteReady = 'true';

    const topic = route.querySelector('[data-bokksu-contact-topic]');
    const orderFields = route.querySelector('[data-bokksu-contact-order-fields]');
    if (!topic || !orderFields) return;

    const conditionalFields = Array.from(orderFields.querySelectorAll('input, textarea, select'));
    const syncOrderFields = () => {
      const showOrderFields = topic.selectedOptions[0]?.hasAttribute('data-bokksu-order-topic') === true;
      orderFields.hidden = !showOrderFields;
      orderFields.setAttribute('aria-hidden', String(!showOrderFields));
      conditionalFields.forEach((field) => {
        field.disabled = !showOrderFields;
      });
    };

    topic.addEventListener('change', syncOrderFields);
    syncOrderFields();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bokksu-faq-route"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-bokksu-faq-route]').forEach((route) => {
    if (route.dataset.faqRouteReady === 'true') return;
    route.dataset.faqRouteReady = 'true';

    const buttons = Array.from(route.querySelectorAll('[data-bokksu-faq-button]'));
    const setExpanded = (button, expanded) => {
      const panel = route.querySelector(`#${CSS.escape(button.getAttribute('aria-controls'))}`);
      button.setAttribute('aria-expanded', String(expanded));
      if (panel) panel.hidden = !expanded;
    };

    let openButton = buttons.find((button) => button.getAttribute('aria-expanded') === 'true');
    if (!openButton && buttons.length > 0) openButton = buttons[0];
    buttons.forEach((button) => setExpanded(button, button === openButton));

    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        const shouldOpen = button.getAttribute('aria-expanded') !== 'true';
        buttons.forEach((candidate) => setExpanded(candidate, shouldOpen && candidate === button));
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bokksu-first-box"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-bokksu-first-box]').forEach((section) => {
    if (section.dataset.carouselReady === 'true') return;
    section.dataset.carouselReady = 'true';
    const slides = Array.from(section.querySelectorAll('[data-slide]'));
    const dots = Array.from(section.querySelectorAll('[data-carousel-dot]'));
    let activeIndex = 0;
    const show = (nextIndex) => {
      activeIndex = (nextIndex + slides.length) % slides.length;
      slides.forEach((slide, index) => {
        const active = index === activeIndex;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      dots.forEach((dot, index) => {
        const active = index === activeIndex;
        dot.classList.toggle('is-active', active);
        if (active) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    };
    section.querySelector('[data-carousel-previous]')?.addEventListener('click', () => show(activeIndex - 1));
    section.querySelector('[data-carousel-next]')?.addEventListener('click', () => show(activeIndex + 1));
    dots.forEach((dot, index) => dot.addEventListener('click', () => show(index)));
    show(0);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bokksu-gift-pdp"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-bokksu-gift-pdp]').forEach((section) => {
    if (section.dataset.giftPdpReady === 'true') return;
    section.dataset.giftPdpReady = 'true';

    const thumbs = Array.from(section.querySelectorAll('[data-bokksu-gift-thumb]'));
    const slides = Array.from(section.querySelectorAll('[data-bokksu-gift-slide]'));
    const galleryStage = section.querySelector('[data-bokksu-gift-stage]');
    const galleryStatus = section.querySelector('[data-bokksu-gift-gallery-status]');
    let activeMediaIndex = 0;

    const selectMedia = (index, focusThumb = false) => {
      if (!slides.length) return;
      activeMediaIndex = Math.max(0, Math.min(slides.length - 1, index));
      slides.forEach((slide, slideIndex) => {
        const active = slideIndex === activeMediaIndex;
        slide.classList.toggle('is-active', active);
        slide.hidden = !active;
      });
      thumbs.forEach((thumb, thumbIndex) => {
        const active = thumbIndex === activeMediaIndex;
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-current', active ? 'true' : 'false');
      });
      if (galleryStatus && thumbs[activeMediaIndex]) {
        galleryStatus.textContent = thumbs[activeMediaIndex].getAttribute('aria-label') || '';
      }
      if (focusThumb) thumbs[activeMediaIndex]?.focus();
    };

    thumbs.forEach((thumb, index) => {
      thumb.addEventListener('click', () => selectMedia(index));
      thumb.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        let nextIndex = index;
        if (event.key === 'Home') nextIndex = 0;
        else if (event.key === 'End') nextIndex = thumbs.length - 1;
        else if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex = (index + 1) % thumbs.length;
        else nextIndex = (index - 1 + thumbs.length) % thumbs.length;
        selectMedia(nextIndex, true);
      });
    });

    galleryStage?.addEventListener('keydown', (event) => {
      if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();
      if (event.key === 'Home') selectMedia(0);
      else if (event.key === 'End') selectMedia(slides.length - 1);
      else if (event.key === 'ArrowRight') selectMedia((activeMediaIndex + 1) % slides.length);
      else selectMedia((activeMediaIndex - 1 + slides.length) % slides.length);
    });

    let pointerStartX = null;
    galleryStage?.addEventListener('pointerdown', (event) => {
      if (event.target.closest('button, a, input, video')) return;
      pointerStartX = event.clientX;
    });
    galleryStage?.addEventListener('pointerup', (event) => {
      if (pointerStartX === null) return;
      const distance = event.clientX - pointerStartX;
      pointerStartX = null;
      if (Math.abs(distance) < 40) return;
      if (distance < 0) selectMedia((activeMediaIndex + 1) % slides.length);
      else selectMedia((activeMediaIndex - 1 + slides.length) % slides.length);
    });
    galleryStage?.addEventListener('pointercancel', () => {
      pointerStartX = null;
    });

    const options = Array.from(section.querySelectorAll('[data-bokksu-gift-option]'));
    const variantInput = section.querySelector('[data-bokksu-gift-variant]');
    const sellingPlanInput = section.querySelector('[data-bokksu-gift-selling-plan]');
    const selectedName = section.querySelector('[data-bokksu-gift-selected-name]');
    const selectedTerm = section.querySelector('[data-bokksu-gift-selected-term]');
    const unitLabel = section.querySelector('[data-bokksu-gift-unit-label]');
    const perDelivery = section.querySelector('[data-bokksu-gift-per-delivery]');
    const checkoutTotal = section.querySelector('[data-bokksu-gift-checkout-total]');
    const compareTotal = section.querySelector('[data-bokksu-gift-compare-total]');
    const savingTotal = section.querySelector('[data-bokksu-gift-saving-total]');
    const quantityInput = section.querySelector('[data-bokksu-gift-quantity] input');
    const addButton = section.querySelector('[ref="addToCartButton"]');
    const addButtonText = section.querySelector('[data-bokksu-gift-add-text]');
    const currency = section.dataset.currency || 'USD';
    const locale = section.dataset.locale || undefined;
    const ctaLabel = section.dataset.ctaLabel || '';
    const unavailableLabel = section.dataset.unavailableLabel || '';
    const moneyFormatter = new Intl.NumberFormat(locale, { style: 'currency', currency });
    let activeOption = options.find((option) => option.classList.contains('is-active')) || options[0];

    const quantityValue = () => Math.max(1, Number.parseInt(quantityInput?.value || '1', 10) || 1);
    const formatMoney = (cents) => moneyFormatter.format(Number(cents || 0) / 100);

    const updateSummary = () => {
      if (!activeOption) return;
      const quantity = quantityValue();
      const sellingPlanId = activeOption.dataset.sellingPlanId || '';
      const totalCents = Number(activeOption.dataset.totalCents || 0) * quantity;
      const compareCents = Number(activeOption.dataset.compareCents || 0) * quantity;
      const savingCents = Number(activeOption.dataset.savingCents || 0) * quantity;
      const available = activeOption.dataset.available === 'true';

      if (variantInput) variantInput.value = activeOption.dataset.variantId || '';
      if (sellingPlanInput) {
        sellingPlanInput.value = sellingPlanId;
        sellingPlanInput.disabled = !sellingPlanId;
      }
      if (selectedName) selectedName.textContent = activeOption.dataset.optionName || '';
      if (selectedTerm) selectedTerm.textContent = activeOption.dataset.optionTerm || '';
      if (unitLabel) unitLabel.textContent = activeOption.dataset.unitLabel || '';
      if (perDelivery) perDelivery.textContent = formatMoney(activeOption.dataset.perDeliveryCents || 0);
      if (checkoutTotal) checkoutTotal.textContent = formatMoney(totalCents);
      if (compareTotal) {
        compareTotal.textContent = compareCents > totalCents ? formatMoney(compareCents) : '';
        compareTotal.hidden = compareCents <= totalCents;
      }
      if (savingTotal) {
        savingTotal.textContent = savingCents > 0 ? `${savingTotal.dataset.label || ''} ${formatMoney(savingCents)}`.trim() : '';
        savingTotal.hidden = savingCents <= 0;
      }
      if (addButton) addButton.disabled = !available;
      if (addButtonText) addButtonText.textContent = available ? ctaLabel : unavailableLabel;
    };

    const selectOption = (option, focus = false) => {
      if (!option || option.disabled) return;
      activeOption = option;
      options.forEach((candidate) => {
        const active = candidate === option;
        candidate.classList.toggle('is-active', active);
        candidate.setAttribute('aria-checked', active ? 'true' : 'false');
        candidate.tabIndex = active ? 0 : -1;
      });
      updateSummary();
      if (focus) option.focus();
    };

    const moveOption = (currentIndex, direction) => {
      if (!options.length) return;
      for (let offset = 1; offset <= options.length; offset += 1) {
        const candidateIndex = (currentIndex + (direction * offset) + options.length) % options.length;
        if (!options[candidateIndex].disabled) {
          selectOption(options[candidateIndex], true);
          return;
        }
      }
    };

    options.forEach((option) => option.addEventListener('click', () => selectOption(option)));
    section.querySelector('[data-bokksu-gift-options]')?.addEventListener('keydown', (event) => {
      const currentIndex = options.indexOf(document.activeElement);
      if (currentIndex < 0) return;
      if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
        event.preventDefault();
        moveOption(currentIndex, 1);
      } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
        event.preventDefault();
        moveOption(currentIndex, -1);
      } else if (event.key === 'Home') {
        event.preventDefault();
        const firstAvailable = options.find((option) => !option.disabled);
        selectOption(firstAvailable, true);
      } else if (event.key === 'End') {
        event.preventDefault();
        const lastAvailable = [...options].reverse().find((option) => !option.disabled);
        selectOption(lastAvailable, true);
      }
    });

    const setQuantity = (value) => {
      if (!quantityInput) return;
      quantityInput.value = String(Math.max(1, Number.parseInt(String(value), 10) || 1));
      updateSummary();
    };

    section.querySelector('[data-bokksu-gift-quantity-minus]')?.addEventListener('click', () => setQuantity(quantityValue() - 1));
    section.querySelector('[data-bokksu-gift-quantity-plus]')?.addEventListener('click', () => setQuantity(quantityValue() + 1));
    quantityInput?.addEventListener('input', updateSummary);
    quantityInput?.addEventListener('change', () => setQuantity(quantityValue()));

    if (activeOption && !activeOption.disabled) {
      selectOption(activeOption);
    } else {
      selectOption(options.find((option) => !option.disabled));
    }
    selectMedia(0);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bokksu-product-route"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-bokksu-product-route]').forEach((route) => {
    if (route.dataset.productRouteReady === 'true') return;
    route.dataset.productRouteReady = 'true';

    const thumbs = Array.from(route.querySelectorAll('[data-bokksu-product-thumb]'));
    const panels = Array.from(route.querySelectorAll('[data-bokksu-product-media]'));
    const selectMedia = (index, focus = false) => {
      thumbs.forEach((thumb, thumbIndex) => {
        const active = thumbIndex === index;
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-current', active ? 'true' : 'false');
      });
      panels.forEach((panel, panelIndex) => {
        const active = panelIndex === index;
        panel.classList.toggle('is-active', active);
        panel.hidden = !active;
      });
      if (focus) thumbs[index]?.focus();
    };

    thumbs.forEach((thumb, index) => {
      thumb.addEventListener('click', () => selectMedia(index));
      thumb.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        let target = index;
        if (event.key === 'Home') target = 0;
        else if (event.key === 'End') target = thumbs.length - 1;
        else if (['ArrowRight', 'ArrowDown'].includes(event.key)) target = (index + 1) % thumbs.length;
        else target = (index - 1 + thumbs.length) % thumbs.length;
        selectMedia(target, true);
      });
    });

    const quantity = route.querySelector('[data-bokksu-quantity] input');
    route.querySelector('[data-bokksu-quantity-minus]')?.addEventListener('click', () => {
      quantity.value = String(Math.max(1, Number(quantity.value || 1) - 1));
      quantity.dispatchEvent(new Event('change', { bubbles: true }));
    });
    route.querySelector('[data-bokksu-quantity-plus]')?.addEventListener('click', () => {
      quantity.value = String(Math.max(1, Number(quantity.value || 1) + 1));
      quantity.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bokksu-subscription-pdp"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-bokksu-subscription-pdp]').forEach((section) => {
    if (section.dataset.subscriptionPdpReady === 'true') return;
    section.dataset.subscriptionPdpReady = 'true';

    const thumbs = Array.from(section.querySelectorAll('[data-bokksu-subscription-thumb]'));
    const slides = Array.from(section.querySelectorAll('[data-bokksu-subscription-slide]'));
    const galleryStage = section.querySelector('[data-bokksu-subscription-stage]');
    const galleryStatus = section.querySelector('[data-bokksu-gallery-status]');
    let activeMediaIndex = 0;

    const selectMedia = (index, focusThumb = false) => {
      if (!slides.length) return;
      activeMediaIndex = Math.max(0, Math.min(slides.length - 1, index));
      slides.forEach((slide, slideIndex) => {
        const active = slideIndex === activeMediaIndex;
        slide.classList.toggle('is-active', active);
        slide.hidden = !active;
      });
      thumbs.forEach((thumb, thumbIndex) => {
        const active = thumbIndex === activeMediaIndex;
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-current', active ? 'true' : 'false');
      });
      if (galleryStatus && thumbs[activeMediaIndex]) {
        galleryStatus.textContent = thumbs[activeMediaIndex].getAttribute('aria-label') || '';
      }
      if (focusThumb) thumbs[activeMediaIndex]?.focus();
    };

    thumbs.forEach((thumb, index) => {
      thumb.addEventListener('click', () => selectMedia(index));
      thumb.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        let nextIndex = index;
        if (event.key === 'Home') nextIndex = 0;
        else if (event.key === 'End') nextIndex = thumbs.length - 1;
        else if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex = (index + 1) % thumbs.length;
        else nextIndex = (index - 1 + thumbs.length) % thumbs.length;
        selectMedia(nextIndex, true);
      });
    });

    galleryStage?.addEventListener('keydown', (event) => {
      if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();
      if (event.key === 'Home') selectMedia(0);
      else if (event.key === 'End') selectMedia(slides.length - 1);
      else if (event.key === 'ArrowRight') selectMedia((activeMediaIndex + 1) % slides.length);
      else selectMedia((activeMediaIndex - 1 + slides.length) % slides.length);
    });

    let pointerStartX = null;
    galleryStage?.addEventListener('pointerdown', (event) => {
      if (event.target.closest('button, a, input, video')) return;
      pointerStartX = event.clientX;
    });
    galleryStage?.addEventListener('pointerup', (event) => {
      if (pointerStartX === null) return;
      const distance = event.clientX - pointerStartX;
      pointerStartX = null;
      if (Math.abs(distance) < 40) return;
      if (distance < 0) selectMedia((activeMediaIndex + 1) % slides.length);
      else selectMedia((activeMediaIndex - 1 + slides.length) % slides.length);
    });
    galleryStage?.addEventListener('pointercancel', () => {
      pointerStartX = null;
    });

    const plans = Array.from(section.querySelectorAll('[data-bokksu-subscription-plan]'));
    const sellingPlanInput = section.querySelector('[data-bokksu-selling-plan]');
    const selectedPlanName = section.querySelector('[data-bokksu-selected-plan]');
    const checkoutTotal = section.querySelector('[data-bokksu-checkout-total]');
    const compareTotal = section.querySelector('[data-bokksu-compare-total]');
    const savingTotal = section.querySelector('[data-bokksu-saving-total]');
    const quantityInput = section.querySelector('[data-bokksu-subscription-quantity] input');
    const currency = section.dataset.currency || 'USD';
    const locale = section.dataset.locale || undefined;
    const moneyFormatter = new Intl.NumberFormat(locale, { style: 'currency', currency });
    let activePlan = plans.find((plan) => plan.classList.contains('is-active')) || plans[0];

    const quantityValue = () => Math.max(1, Number.parseInt(quantityInput?.value || '1', 10) || 1);
    const formatMoney = (cents) => moneyFormatter.format(Number(cents || 0) / 100);

    const updateSummary = () => {
      if (!activePlan) return;
      const quantity = quantityValue();
      const sellingPlanId = activePlan.dataset.sellingPlanId || '';
      const totalCents = Number(activePlan.dataset.totalCents || 0) * quantity;
      const compareCents = Number(activePlan.dataset.compareCents || 0) * quantity;
      const savingCents = Number(activePlan.dataset.savingCents || 0) * quantity;

      if (sellingPlanInput) {
        sellingPlanInput.value = sellingPlanId;
        sellingPlanInput.disabled = !sellingPlanId;
      }
      if (selectedPlanName) selectedPlanName.textContent = activePlan.dataset.planName || '';
      if (checkoutTotal) checkoutTotal.textContent = formatMoney(totalCents);
      if (compareTotal) {
        compareTotal.textContent = compareCents > totalCents ? formatMoney(compareCents) : '';
        compareTotal.hidden = compareCents <= totalCents;
      }
      if (savingTotal) {
        savingTotal.textContent = savingCents > 0 ? `${savingTotal.dataset.label || ''} ${formatMoney(savingCents)}`.trim() : '';
        savingTotal.hidden = savingCents <= 0;
      }
    };

    const selectPlan = (plan, focus = false) => {
      activePlan = plan;
      plans.forEach((candidate) => {
        const active = candidate === plan;
        candidate.classList.toggle('is-active', active);
        candidate.setAttribute('aria-checked', active ? 'true' : 'false');
        candidate.tabIndex = active ? 0 : -1;
      });
      updateSummary();
      if (focus) plan.focus();
    };

    plans.forEach((plan) => plan.addEventListener('click', () => selectPlan(plan)));
    section.querySelector('[data-bokksu-subscription-plans]')?.addEventListener('keydown', (event) => {
      const currentIndex = plans.indexOf(document.activeElement);
      if (currentIndex < 0) return;
      let nextIndex = null;
      if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex = (currentIndex + 1) % plans.length;
      else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') nextIndex = (currentIndex - 1 + plans.length) % plans.length;
      else if (event.key === 'Home') nextIndex = 0;
      else if (event.key === 'End') nextIndex = plans.length - 1;
      if (nextIndex === null) return;
      event.preventDefault();
      selectPlan(plans[nextIndex], true);
    });

    const setQuantity = (value) => {
      if (!quantityInput) return;
      quantityInput.value = String(Math.max(1, Number.parseInt(String(value), 10) || 1));
      updateSummary();
    };

    section.querySelector('[data-bokksu-quantity-minus]')?.addEventListener('click', () => setQuantity(quantityValue() - 1));
    section.querySelector('[data-bokksu-quantity-plus]')?.addEventListener('click', () => setQuantity(quantityValue() + 1));
    quantityInput?.addEventListener('input', updateSummary);
    quantityInput?.addEventListener('change', () => {
      if (quantityInput) quantityInput.value = String(quantityValue());
      updateSummary();
    });

    if (activePlan) selectPlan(activePlan);
    selectMedia(0);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bokksu-subscription-picker"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-bokksu-subscription]').forEach((section) => {
    if (section.dataset.subscriptionReady === 'true') return;
    section.dataset.subscriptionReady = 'true';

    const plans = Array.from(section.querySelectorAll('[data-subscription-plan]'));
    const sellingPlanInput = section.querySelector('[data-subscription-selling-plan]');
    const totalPrice = section.querySelector('[data-subscription-total-price]');
    const comparePrice = section.querySelector('[data-subscription-compare-price]');
    const totalSave = section.querySelector('[data-subscription-total-save]');
    const billingNote = section.querySelector('[data-subscription-billing-note]');

    const selectPlan = (plan, focus = false) => {
      plans.forEach((candidate) => {
        const active = candidate === plan;
        candidate.classList.toggle('is-active', active);
        candidate.setAttribute('aria-checked', active ? 'true' : 'false');
        candidate.tabIndex = active ? 0 : -1;
        candidate.querySelector('.bokksu-subscription__promo')?.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      const sellingPlanId = plan.dataset.sellingPlanId || '';
      if (sellingPlanInput) {
        sellingPlanInput.value = sellingPlanId;
        sellingPlanInput.disabled = !sellingPlanId;
      }
      if (totalPrice) totalPrice.textContent = plan.dataset.totalPrice || '';
      if (comparePrice) {
        comparePrice.textContent = plan.dataset.comparePrice || '';
        comparePrice.hidden = !plan.dataset.comparePrice;
      }
      if (totalSave) {
        totalSave.textContent = plan.dataset.saveText || '';
        totalSave.hidden = !plan.dataset.saveText;
      }
      if (billingNote) billingNote.textContent = plan.dataset.billingNote || '';
      if (focus) plan.focus();
    };

    plans.forEach((plan) => plan.addEventListener('click', () => selectPlan(plan)));
    section.querySelector('[data-subscription-plans]')?.addEventListener('keydown', (event) => {
      const currentIndex = plans.indexOf(document.activeElement);
      if (currentIndex < 0) return;
      let nextIndex = null;
      if (event.key === 'ArrowDown' || event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % plans.length;
      if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + plans.length) % plans.length;
      if (nextIndex !== null) {
        event.preventDefault();
        selectPlan(plans[nextIndex], true);
      }
      if (event.key === ' ' || event.key === 'Enter') {
        event.preventDefault();
        selectPlan(plans[currentIndex], true);
      }
    });

    const thumbnails = Array.from(section.querySelectorAll('[data-subscription-thumb]'));
    const mainImage = section.querySelector('[data-subscription-main-image] img');
    thumbnails.forEach((thumbnail) => thumbnail.addEventListener('click', () => {
      thumbnails.forEach((candidate) => {
        candidate.classList.remove('is-active');
        candidate.removeAttribute('aria-current');
      });
      thumbnail.classList.add('is-active');
      thumbnail.setAttribute('aria-current', 'true');
      if (mainImage) {
        mainImage.src = thumbnail.dataset.galleryUrl || mainImage.src;
        mainImage.removeAttribute('srcset');
        mainImage.alt = thumbnail.dataset.galleryAlt || '';
      }
    }));
    section.querySelector('[data-subscription-thumb-next]')?.addEventListener('click', () => {
      section.querySelector('[data-subscription-thumbs]')?.scrollBy({ top: 95, behavior: 'smooth' });
    });

    const carousel = section.querySelector('[data-subscription-carousel]');
    const slides = Array.from(section.querySelectorAll('[data-subscription-slide]'));
    const dots = Array.from(section.querySelectorAll('[data-subscription-dot]'));
    let scrollTimer;
    const setActiveSlide = (activeIndex) => {
      slides.forEach((slide, index) => slide.setAttribute('aria-hidden', index === activeIndex ? 'false' : 'true'));
      dots.forEach((dot, index) => {
        const active = index === activeIndex;
        dot.classList.toggle('is-active', active);
        if (active) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    };
    carousel?.addEventListener('scroll', () => {
      window.clearTimeout(scrollTimer);
      scrollTimer = window.setTimeout(() => {
        const slideWidth = slides[0]?.offsetWidth || 1;
        setActiveSlide(Math.max(0, Math.min(slides.length - 1, Math.round(carousel.scrollLeft / slideWidth))));
      }, 60);
    });
    dots.forEach((dot, index) => dot.addEventListener('click', () => {
      const slideWidth = slides[0]?.offsetWidth || 0;
      carousel?.scrollTo({ left: slideWidth * index, behavior: 'smooth' });
    }));

    const activePlan = plans.find((plan) => plan.classList.contains('is-active')) || plans[0];
    if (activePlan) selectPlan(activePlan);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bokksu-testimonials"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-bokksu-testimonials]').forEach((section) => {
    if (section.dataset.carouselReady === 'true') return;
    section.dataset.carouselReady = 'true';
    const track = section.querySelector('[data-testimonial-track]');
    const slides = Array.from(section.querySelectorAll('[data-testimonial-slide]'));
    const status = section.querySelector('[data-testimonial-status]');
    if (!track || slides.length < 2) return;

    let firstVisibleIndex = 0;
    const visibleCount = () => (window.matchMedia('(min-width: 769px)').matches ? 5 : 1);
    const update = (announce, direction = 0) => {
      if (visibleCount() === 5 && firstVisibleIndex !== 0 && firstVisibleIndex !== 5) {
        firstVisibleIndex = 0;
      }
      slides.forEach((slide, slideIndex) => {
        slide.style.order = String((slideIndex - firstVisibleIndex + slides.length) % slides.length);
      });
      if (direction !== 0) {
        track.style.transition = 'none';
        track.style.transform = `translateX(${direction * (100 / visibleCount())}%)`;
        track.getBoundingClientRect();
        track.style.transition = '';
        requestAnimationFrame(() => {
          track.style.transform = 'translateX(0)';
        });
      } else {
        track.style.transform = 'translateX(0)';
      }
      slides.forEach((slide, slideIndex) => {
        const circularPosition = (slideIndex - firstVisibleIndex + slides.length) % slides.length;
        const visible = circularPosition < visibleCount();
        slide.setAttribute('aria-hidden', visible ? 'false' : 'true');
      });
      if (announce && status) {
        if (visibleCount() === 1) {
          status.textContent = `Photo ${firstVisibleIndex + 1} of ${slides.length}`;
        } else {
          const labels = Array.from({ length: visibleCount() }, (_, position) => ((firstVisibleIndex + position) % slides.length) + 1);
          status.textContent = `Photos ${labels.join(', ')} of ${slides.length}`;
        }
      }
    };
    const move = (direction) => {
      if (visibleCount() === 5) {
        firstVisibleIndex = firstVisibleIndex === 0 ? 5 : 0;
      } else {
        firstVisibleIndex = (firstVisibleIndex + direction + slides.length) % slides.length;
      }
      update(true, direction);
    };

    section.querySelector('[data-testimonial-previous]')?.addEventListener('click', () => move(-1));
    section.querySelector('[data-testimonial-next]')?.addEventListener('click', () => move(1));
    track.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        move(-1);
      }
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        move(1);
      }
    });
    let pointerStartX = null;
    track.addEventListener('pointerdown', (event) => {
      pointerStartX = event.clientX;
    });
    track.addEventListener('pointerup', (event) => {
      if (pointerStartX === null) return;
      const delta = event.clientX - pointerStartX;
      pointerStartX = null;
      if (Math.abs(delta) < 40) return;
      move(delta < 0 ? 1 : -1);
    });
    track.addEventListener('pointercancel', () => {
      pointerStartX = null;
    });
    window.addEventListener('resize', () => update(false), { passive: true });
    update(false);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
